import {
  CLOSE_WAPP,
  CloseWappAPI,
  Exceptions,
  GET_WAPP_CHILD_OUTPUT,
  GET_WAPP_INPUT,
  GetWappChildOutputAPI,
  GetWappInputAPI,
  START_WAPP,
  StartWappAPI,
  CONNECT_WAPP,
  ConnectWappAPI,
  WappMode,
} from '@weblite-wapps/protocol'
import {
  setWappCustomActions,
  wapprunnerStart,
  addToConnectedWapps,
} from 'weblite-web-wapprunner'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'
import {
  getStaticPanelByWappSessionId,
  isValidStaticWapp,
  OverlayWappPanel,
  WappOverlayLoadingModal,
  WappPanel,
} from '$logic/wapp-panels'
import { getWappInput } from '$logic/wapp-communication/helper/wapps.helper'
import { sendWappPendingMessages } from '$logic/wapp-communication/helper/pending-events-to-send'

wappSubscription.subscribe<ConnectWappAPI>(CONNECT_WAPP, async (_, meta) => {
  addToConnectedWapps(meta.wappSessionId)
  return { status: 'ok' }
})

wappSubscription.subscribe<StartWappAPI>(
  START_WAPP,
  async ({ customActions }, meta) => {
    wapprunnerStart(meta.wappSessionId)
    sendWappPendingMessages(meta.wappSessionId)

    if (customActions?.length)
      setWappCustomActions(meta.wappSessionId, customActions)

    if (meta.mode === WappMode.OVERLAY) await WappOverlayLoadingModal.hide()
    return { status: 'ok' }
  },
)

wappSubscription.subscribe<GetWappInputAPI>(GET_WAPP_INPUT, async (_, meta) => {
  const { wappSessionId, wisId } = meta
  return getWappInput(wappSessionId, wisId)
})

wappSubscription.subscribe<GetWappChildOutputAPI>(
  GET_WAPP_CHILD_OUTPUT,
  async (_, { mode }) => {
    if (mode === WappMode.STATIC || mode === WappMode.INLINE)
      return { errorCode: Exceptions.INVALID }

    if (mode === WappMode.MAIN) {
      const { childOutput } = WappPanel.getTopWappMeta()
      return childOutput
    }

    if (mode === WappMode.OVERLAY) {
      const { childOutput } = OverlayWappPanel.getTopWappMeta()
      return childOutput
    }
  },
)

wappSubscription.subscribe<CloseWappAPI>(
  CLOSE_WAPP,
  async ({ output }, meta) => {
    if (meta.mode === WappMode.MAIN) {
      await WappPanel.closeTopWapp(output)
      return { status: 'ok' }
    }

    if (isValidStaticWapp(meta)) {
      await getStaticPanelByWappSessionId(meta.wappSessionId).close()
      return { status: 'ok' }
    }

    if (meta.mode === WappMode.OVERLAY) {
      await OverlayWappPanel.closeTopWapp(output)
      return { status: 'ok' }
    }

    return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
  },
)
